import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@app/modules/live/services/utility.service';

@Component({
    selector: 'app-icon-resolver',
    templateUrl: './icon-resolver.component.html',
    styleUrls: ['./icon-resolver.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconResolverComponent {

    @Input() icon: any;
    @Input() iconSize: any;
    @Input() iconColor: any = '#000000';

    constructor(private utilityService: UtilityService ) { }

    get(): any {
        return  this.utilityService.resolveIcon(this.icon);
    }

}
